export enum ManagementType {
	Box = 'Box',
	Workflow = 'Workflow',
}
